import React from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Render error caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--sj-sidebar, #EDF2F4)" }} data-testid="error-boundary">
          <div className="max-w-md w-full bg-white rounded-2xl border p-8 text-center shadow-sm" style={{ borderColor: "#EBE9E4" }}>
            <div className="h-12 w-12 rounded-xl mx-auto flex items-center justify-center mb-4" style={{ background: "#0B5E4E1A" }}>
              <AlertTriangle className="h-6 w-6" style={{ color: "#0B5E4E" }} />
            </div>
            <h1 className="font-head text-xl font-bold" style={{ color: "#141615" }}>Something went wrong</h1>
            <p className="mt-2 text-sm" style={{ color: "#3A3A3A" }}>
              We hit an unexpected error loading this page. Please reload — if it keeps happening, let a church admin know.
            </p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              className="mt-5 rounded-full px-6 py-2.5 text-sm font-semibold text-white transition-opacity hover:opacity-90"
              style={{ background: "#0B5E4E" }}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
